export const form = {
    id: "",
    campaign: "",
    company: "",
    managers: [],
    recruiters: [],
    country: {
        englishName: "Slovenia",
        ietfLanguageTag: "sl-SI",
        languageNativeName: "slovenščina",
        languageEnglishName: "Slovenian",
        code: "SI",
        value: "Slovenija"
    },
    closedAt: "",
    createdAt: "",
    createdBy: ""
}